// extracted by mini-css-extract-plugin
module.exports = {"img":"MessageImgElm_img__pDoD0","container":"MessageImgElm_container__3rQv-","overlay":"MessageImgElm_overlay__3K6ri","imgCon":"MessageImgElm_imgCon__3O-bG"};